
import service from '../Common/'
import constants from '../../../settings/shared/constants'


function getAllEngineapi() {
    let jwtToken = localStorage.getItem('accessToken');
    let headers = { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + jwtToken }
    return service({
        url: constants.api.cluster.getAllEngine,
        method: 'GET',
        headers: headers,
        data: ''
    });
}
function addNewEngine(enginePayload) {
    let jwtToken = localStorage.getItem('accessToken');
    let headers = { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + jwtToken }
    return service({
        url: constants.api.cluster.newEngine,
        method: 'POST',
        headers: headers,
        data: enginePayload
    });
}

function addNewCluster(enginePayload) {
    let jwtToken = localStorage.getItem('accessToken');
    let headers = { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + jwtToken }
    return service({
        url: constants.api.cluster.newCluster,
        method: 'POST',
        headers: headers,
        data: enginePayload
    });
}

function getAllClusters() {
    let jwtToken = localStorage.getItem('accessToken');
    let headers = { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + jwtToken }
    return service({
        url: constants.api.cluster.getAllCluster,
        method: 'GET',
        headers: headers,
        data: ''
    });
}

function getClusterById(id) {
    let jwtToken = localStorage.getItem('accessToken');
    let headers = { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + jwtToken }
    return service({
        url: constants.api.cluster.getClusterByid + id,
        method: 'GET',
        headers: headers,
        data: ''
    });
}

function deleteClusterById(id) {
    let jwtToken = localStorage.getItem('accessToken');
    let headers = { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + jwtToken }
    return service({
        url: constants.api.cluster.deleteClusterByid + id,
        method: 'DELETE',
        headers: headers,
        data: ''
    });
}

function forceRemoveClusterById(id) {
    let jwtToken = localStorage.getItem('accessToken');
    let headers = { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + jwtToken }
    return service({
        url: constants.api.cluster.forceDelete + id,
        method: 'DELETE',
        headers: headers,
        data: ''
    });
}

function getMachineTypes(cloudType) {
    let jwtToken = localStorage.getItem('accessToken');
    let headers = { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + jwtToken }
    return service({
        url: constants.api.cluster.getmachinetypes + cloudType,
        method: 'GET',
        headers: headers,
        data: ''
    });
}

function clusterClone(id) {
    let jwtToken = localStorage.getItem('accessToken');
    let headers = { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + jwtToken }
    return service({
        url: constants.api.cluster.cloneK8s + id,
        method: 'GET',
        headers: headers,
        data: ''
    });
}

function clusterRestart(id) {
    let jwtToken = localStorage.getItem('accessToken');
    let headers = { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + jwtToken }
    return service({
        url: constants.api.cluster.restartK8s + id,
        method: 'GET',
        headers: headers,
        data: ''
    });
}

function clusterLiveStatus(id) {
    let jwtToken = localStorage.getItem('accessToken');
    let headers = { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + jwtToken }
    return service({
        url: constants.api.cluster.liveStatusK8s + id,
        method: 'GET',
        headers: headers,
        data: ''
    });
}

function clusterStart(id) {
    let jwtToken = localStorage.getItem('accessToken');
    let headers = { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + jwtToken }
    return service({
        url: constants.api.cluster.startK8s + id,
        method: 'GET',
        headers: headers,
        data: ''
    });
}

function clusterStop(id) {
    let jwtToken = localStorage.getItem('accessToken');
    let headers = { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + jwtToken }
    return service({
        url: constants.api.cluster.stopK8s + id,
        method: 'GET',
        headers: headers,
        data: ''
    });
}

function getCloudImageName(cloudType) {
    let jwtToken = localStorage.getItem('accessToken');
    let headers = { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + jwtToken }
    return service({
        url: constants.api.cloud.getCloudImageName + cloudType,
        method: 'GET',
        headers: headers,
        data: ''
    });
}



function getInstanceTypeAlias(cloudType) {
    let jwtToken = localStorage.getItem('accessToken');
    let headers = { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + jwtToken }
    return service({
        url: constants.api.cloud.getInstanceTypeAlias + cloudType,
        method: 'GET',
        headers: headers,
        data: ''
    });
}

function getAllVirtualMachineType() {
    let jwtToken = localStorage.getItem('accessToken');
    let headers = {'Content-Type':'application/json', 'Authorization':'Bearer '+ jwtToken}
    return service({
        url: constants.api.cloud.getAllVirtualMachineType,
        method:'GET',
        headers:headers,
        data:''
    });

}

function getInstanceTypeHint(cloudType) {
    let jwtToken = localStorage.getItem('accessToken');
    let headers = { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + jwtToken }
    return service({
        url: constants.api.cloud.getInstanceTypeHint + cloudType,
        method: 'GET',
        headers: headers,
        data: ''
    });
}

function getAllProvisioner() {
    let jwtToken = localStorage.getItem('accessToken');
    let headers = {'Content-Type':'application/json', 'Authorization':'Bearer '+ jwtToken}
    return service({
        url: constants.api.provisioner.getAllProvisioner,
        method:'GET',
        headers:headers,
        data:''
    });
}

function getAliasNameByProvisioner(provisionerName) {

    let jwtToken = localStorage.getItem('accessToken');
    let headers = {'Content-Type':'application/json', 'Authorization':'Bearer '+ jwtToken}
    return service({
        url: constants.api.cloud.getAliasNameByProvisioner + provisionerName,
        method:'GET',
        headers:headers,
        data:''
    });
}   

function getAllCloudImages() {
    let jwtToken = localStorage.getItem('accessToken');
    let headers = {'Content-Type':'application/json', 'Authorization':'Bearer '+ jwtToken}
    return service({
        url: constants.api.cloud.getAllCloudImages,
        method:'GET',
        headers:headers,
        data:''
    });
}

//To export authentication function
const ClusterService = {
    getAllEngineapi,addNewEngine,addNewCluster,getAllClusters,getClusterById,deleteClusterById,getMachineTypes,
    clusterClone,clusterStart,clusterStop,clusterRestart,clusterLiveStatus, getCloudImageName, getInstanceTypeAlias,getAliasNameByProvisioner,
    getInstanceTypeHint, getAllProvisioner, forceRemoveClusterById, getAllVirtualMachineType, getAllCloudImages
}

export default ClusterService;
